import { TReferralsPartnersRow } from 'redux/reducers/referrals/types';
import { TUser } from 'redux/reducers/user/types';
import { DATES_ID, DATES } from 'services/constants/dates-constants';
import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
// {
// 	"id": 1,
// 	"emId": 2,
// 	"partnerId": 1,
// 	"createdAt": "2025-06-10T13:21:35.780131Z",
// 	"fullName": "EAS super store (old K-Mart)",
// 	"enabled": true,
// 	"partnerName": "New Partner",
// 	"partnersFee": 10,
// 	"registrationAddress": "registrationAddress",
// 	"bankAccountDetails": "bankAccountDetails",
// 	"createdBy": {
// 		"id": "74ce3b5e-a492-49ae-8d8a-8609b275805d",
// 		"email": "andrii@easproject.com",
// 		"fullName": "Andrii"
// 	}
// },

export const tableStructureFunction = ({
	usersList,
}: {
	usersList: TUser[];
}): TTableStructure<keyof TReferralsPartnersRow>[] => {
	return [
		{
			name: 'ID',
			selector: 'id',
			show: false,
			sortable: true,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'EM ID',
			selector: 'emId',
			show: false,
			sortable: true,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Created at',
			selector: 'createdAt',
			show: true,
			sortable: true,
			filterable: true,
			colSpan: 1,
			type: ETableStructureType.DATE,
			align: ETableStructureAlign.CENTER,
			filter: [
				[DATES_ID.TODAY, DATES.TODAY],
				[DATES_ID.YESTERDAY, DATES.YESTERDAY],
				[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
				[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
				[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
				[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
				[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
				[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
				[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
				[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			],
		},

		{
			name: 'EM Name',
			selector: 'fullName',
			show: true,
			sortable: true,
			filterable: false,
			searchable: true,
			colSpan: 1,
			type: ETableStructureType.EM,
			value: (item: TReferralsPartnersRow) => {
				return { id: item.emId, name: item.fullName };
			},
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Partner Name',
			selector: 'partnerName',
			show: true,
			sortable: true,
			filterable: false,
			searchable: true,
			colSpan: 1,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Registration Address',
			selector: 'registrationAddress',
			show: true,
			sortable: true,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.MULTILINE_TEXT,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Bank Account Details',
			selector: 'bankAccountDetails',
			show: true,
			sortable: true,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
		},
		{
			name: 'Partners Fee',
			selector: 'partnersFee',
			show: true,
			sortable: true,
			filterable: false,
			colSpan: 1,
			type: ETableStructureType.AMOUNT,
			align: ETableStructureAlign.RIGHT,
			currency: (item) => '%',
		},
		{
			name: 'Enabled',
			selector: 'enabled',
			show: true,
			sortable: true,
			filterable: true,
			colSpan: 1,
			type: ETableStructureType.BOOLEAN,
			align: ETableStructureAlign.CENTER,
			filter: [
				['true', 'Enabled'],
				['false', 'Disabled'],
			],
			colors: [
				['true', 'success.light'],
				['false', 'error.light'],
			],
		},
		{
			name: 'Created By',
			selector: 'createdBy',
			show: true,
			sortable: true,
			filterable: true,
			colSpan: 1,
			type: ETableStructureType.USER,
			align: ETableStructureAlign.LEFT,
			filter: usersList?.map((user: TUser) => [user.id, user.fullName]),
		},
		// {
		// 	name: 'Actions',
		// 	selector: 'id',
		// 	show: false,
		// 	sortable: false,
		// 	filterable: false,
		// 	colSpan: 1,
		// 	type: ETableStructureType.BUTTONS,
		// 	align: ETableStructureAlign.RIGHT,
		// 	buttons: ['Edit'],
		// },
	];
};
